import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";

function NotFound() {
  return (
    <>
    <Header />
    <div className="flex flex-col items-center justify-center min-h-screen text-center p-6">
      <h1 className="text-6xl font-bold text-red-500 mb-4">404</h1>
      <p className="text-lg md:text-xl mb-6">Oops! The page you're looking for doesn't exist.</p>
      <Link
        to="/"
        className="px-6 py-3 transition primarybutton"
      >
        Go Home
      </Link>
    </div>
    </>
  );
}

export default NotFound;
